import { render, staticRenderFns } from "./formGuest.vue?vue&type=template&id=36bd0cbb&scoped=true&"
import script from "./formGuest.vue?vue&type=script&lang=ts&"
export * from "./formGuest.vue?vue&type=script&lang=ts&"
import style0 from "./formGuest.vue?vue&type=style&index=0&id=36bd0cbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd0cbb",
  null
  
)

export default component.exports